import { jsx as _jsx } from "react/jsx-runtime";
import { brandName, featuresEnabled } from "@/brands/config";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { Checkbox } from "@gemini/ui";
import { Controller } from "react-hook-form";
export const PartnerSubscriptionOptIn = ({ control, testId }) => {
    const { t } = useI18n();
    const { partnerSubscriptionOptIn } = featuresEnabled;
    if (!partnerSubscriptionOptIn)
        return;
    return (_jsx(Box, { children: _jsx(Controller, { name: "offerOptin", control: control, defaultValue: false, render: ({ field: { value, onChange, name, ref } }) => (_jsx(Checkbox, { isOptional: true, hasNecessityIndicator: false, testId: `${testId}.offerOptin`, isSelected: value !== null && value !== void 0 ? value : false, ref: ref, onChange: onChange, name: name, defaultSelected: false, children: t("contact.form.partner_subscription_opt_in.text", {
                    replace: {
                        value: brandName,
                    },
                }) })) }) }));
};
